/**
 * Carbon tile (DESIGN.md "Cards / Containers"): layer-01 on the ground,
 * square, no border and no shadow. 16px padding by default, 24px on score
 * tiles. Related tiles sit flush inside a CondensedGrid (the Gutter Rule).
 * With `to`, the whole tile is a router link that turns layer-hover on hover
 * (the Command Center pillar tiles).
 */
import type { AnchorHTMLAttributes } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import type { TileProps } from './types'

const PADDING: Record<NonNullable<TileProps['padding']>, string> = {
  0: '',
  16: 'p-4',
  24: 'p-6',
}

export function Tile({ as: Element = 'div', padding = 16, to, className, children, ...rest }: TileProps) {
  const classes = clsx('bg-layer-1 text-text-primary', PADDING[padding], className)
  if (to) {
    return (
      <Link
        to={to}
        className={clsx(classes, 'block transition-colors duration-110 ease-carbon hover:bg-layer-hover')}
        {...(rest as AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {children}
      </Link>
    )
  }
  return (
    <Element className={classes} {...rest}>
      {children}
    </Element>
  )
}

export default Tile
